import web from '../images/java collection framwork.jpg';
import app from '../images/to desing pattern in java.jpg';
import img1 from '../images/aiml.jpg';
import img2 from '../images/aws.jpg';
import android from '../images/devOS.jpg';
import software from '../images/fundamental of docker and kubarnet.jpg';
import img3 from '../images/solid.jpg'
import img4 from '../images/Low level .jpg'









const Sdata =[

    {
        id: 1,
        imgSrc: web,
        title:"Java Collection Framework "
    },
    {
        id: 2,
        imgSrc:app,
        title:"Top Design Patterns in Java",
    },
    {
        id: 3,
        imgSrc: android,
        title:"Build a career in DevOps Engineering"
    },
    {
        id: 4,
        imgSrc: software,
        title:"Fundamentals of Docker & kubernetes "
    },
    {
        id: 5,
        imgSrc:img1,
        title:"AI & ML Projects",
    },
    
    {
        id: 6,
        imgSrc:img2,
        title:"Introduction to Cloud Computing with AWS"
    },

    {
        id: 7,
        imgSrc:img3,
        title:"SOLID Principle Every Developer Must Know"
    },

    {
        id: 8,
        imgSrc:img4,
        title:"Low Level Design of payment Apps"
    },
    

];
export default Sdata;